import { atom } from 'recoil';

export const shareModalState = atom({
  key: 'shareModalState',
  default: {
    isOpen: false,
    metaData: {},
  },
});
